import { IconCrossLarge } from 'central-icons/IconCrossLarge';
import { IconTriangleExclamation } from 'central-icons/IconTriangleExclamation';
import classNames from 'classnames';

import { IconButton, Popover, Text } from '@revelio/ui';

import { ContactSalesButton } from './ContactSalesButton';
import styles from './free-trial-alert.module.css';

export interface FreeTrialAlertModalProps {
  days: number;
  hours: number;
}

export function FreeTrialAlertModal({ days, hours }: FreeTrialAlertModalProps) {
  const status = days > 3 ? 'warning' : 'error';

  const trialEndsText =
    hours < 25
      ? `Your trial ends in ${hours} hour${hours === 1 ? '' : 's'}!`
      : `Your trial ends in ${days} days!`;

  return (
    <Popover
      placement="top-start"
      arrow
      data-testid="free-trial-alert-modal"
      className={styles.popoverContent}
      trigger={
        <div
          role="alert"
          className={classNames(
            styles.chip,
            status === 'error' ? styles.chipError : styles.chipWarning
          )}
        >
          <IconTriangleExclamation size={16} className={styles.warningGlyph} />
          <span
            className={styles.chipTitle}
            data-testid="free-trial-alert-title"
          >
            {trialEndsText}
          </span>
        </div>
      }
    >
      {({ close }) => (
        <>
          <div className={styles.popoverHeader}>
            <IconTriangleExclamation
              size={18}
              ariaHidden={true}
              className={styles.popoverStatusIcon}
            />
            <Text fontSize="md" className={styles.popoverTitle}>
              {trialEndsText}
            </Text>
            <IconButton
              aria-label="Close"
              variant="ghost"
              size="sm"
              shape="squared"
              icon={<IconCrossLarge size={16} ariaHidden={true} />}
              onClick={close}
              className={styles.popoverClose}
            />
          </div>
          <Text fontSize="sm" className={styles.popoverBody}>
            Want to extend your trial?
          </Text>
          <div className={styles.popoverFooter}>
            <ContactSalesButton onClick={close} buttonProps={{ size: 'sm' }} />
          </div>
        </>
      )}
    </Popover>
  );
}
